import { render, staticRenderFns } from "./AdminInputListWrapper.vue?vue&type=template&id=c79a9982&scoped=true&"
import script from "./AdminInputListWrapper.vue?vue&type=script&lang=js&"
export * from "./AdminInputListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AdminInputListWrapper.vue?vue&type=style&index=0&id=c79a9982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79a9982",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
